import { render, staticRenderFns } from "./SelectResourceReadOnly.vue?vue&type=template&id=f91a77a8&"
import script from "./SelectResourceReadOnly.vue?vue&type=script&lang=js&"
export * from "./SelectResourceReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f91a77a8')) {
      api.createRecord('f91a77a8', component.options)
    } else {
      api.reload('f91a77a8', component.options)
    }
    module.hot.accept("./SelectResourceReadOnly.vue?vue&type=template&id=f91a77a8&", function () {
      api.rerender('f91a77a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select-resource/SelectResourceReadOnly.vue"
export default component.exports